import {PricingBreakdown} from "../../api/models";
import {Tooltip} from "antd";
import React from "react";
import Utils from "../../util/util";

export const TotalPriceDisplay = (props:{
    quotePricingDetails: PricingBreakdown | undefined
}) => {

    const { quotePricingDetails } = props;

    const pricingDetails = quotePricingDetails;

    if ( pricingDetails === undefined ) return <></>

    const isDifferent = quotePricingDetails?.totalPrice !== (pricingDetails?.totalPrice || 0);
    const tooltip =  isDifferent && <Tooltip title="This price reflects unsaved changes to the quote.">
      <span style={{color: "blue"}}>*</span>
    </Tooltip>

    return <div style={{whiteSpace: "nowrap"}}>
        <div>
            Dealer Price: {Utils.formatMoney(pricingDetails?.dealerPrice)}{tooltip}
        </div>
        <div>
            Customer Price: <span data-testid="total-price-display" >{Utils.formatMoney(pricingDetails?.totalPrice)}</span>{tooltip}
        </div>
    </div>
}

export default TotalPriceDisplay;
